<template>
  <header class="header" :class="{ 'is-preview': previewStatus }">
    <a class="logo" @click="gotoshares">
      <img src="@/assets/logo.svg" alt="logo">
      <span class="text" v-text="$t('header.title_letmesee')"></span>
    </a>
    <div class="share-info" v-show="previewStatus">
      <div class="share-info__title" v-text="shareInfo.title"></div>
      <div class="share-info__label" v-text="shareInfo.label"></div>
    </div>
    <div class="app-store">
      <AppLink type="google" class="item" />
      <AppLink type="apple" class="item" />
    </div>
  </header>
</template>

<script>
import dayjs from 'dayjs'
import { mapGetters } from 'vuex'
import AppLink from '@/components/app-link'

export default {
  name: 'Header',
  components: {
    AppLink
  },
  computed: {
    ...mapGetters([
      'previewFile',
      'previewStatus',
      'currentStore'
    ]),
    shareInfo() {
      if (this.previewStatus && this.previewFile) {
        const title = this.$t('header.share_title', {
          type: this.$t(`header.label_${this.previewFile.type == 'picture' ? 'photo' : 'video'}`),
          username: this.previewFile.owner
        })
        const label = this.$t('header.share_label', {
          date: dayjs(+this.previewFile.sharedAt).format('MM/DD/YYYY')
        })

        return {
          title,
          label
        }
      }
      return {
        title: '',
        label: ''
      }
    }
  },
  methods: {
    gotoshares() {
      if (this.previewStatus && this.currentStore.length > 1) {
        const { shareId } = this.$route.params

        this.$router.push(`/shares/${shareId}`)
      }
    }
  }
}
</script>

<style lang="less">
  @import url("~@/styles/var.less");

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 72px;
    margin: 0;
    padding: 0 20px;
    border-bottom: 1px solid var(--border-color, @grey-200);
    background-color: var(--background-color, @white);
    .logo {
      display: inline-flex;
      align-items: center;
      justify-content: flex-start;
      font-weight: bold;
      font-size: 16px;
      line-height: 24px;
      text-decoration: none;
      cursor: pointer;
      .text {
        margin-left: 12px;
        color: var(--title-color, @grey-600)
      }
    }
    .share-info {
      flex: 0 0 50%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-style: normal;
      font-weight: normal;
      line-height: 20px;
      padding: 0 16px;
      overflow: hidden;
      &__title {
        width: 100%;
        color: var(--title-color, @dark);
        font-weight: 400;
        font-size: 15px;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      &__label {
        color: @grey-600;
        font-size: 12px;
      }
    }
    .app-store {
      display: inline-flex;
      align-items: center;
      justify-content: flex-end;
      .item:last-child {
        margin-left: 16px;
      }
    }
  }

  @media screen and (max-width: 1024px), screen and (max-height: 576px) {
    .header {
      flex-direction: column;
      height: 48px;
      padding: 0;
      border-bottom: none;
      &.is-preview {
        height: 96px;
      }
      .logo,
      .share-info {
        width: 100%;
        flex: 0 0 48px;
        align-items: center;
        justify-content: center;
      }
      .logo {
        border-bottom: 1px solid var(--border-color, @grey-200);
      }
      .share-info {
        background-color: var(--background-color, @background-color);
      }
      .app-store {
        display: none;
      }
    }
  }
</style>
